/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Foot_PedalInputs */



/**
* | output |
* | --- |
* | "Foot Pedal Control" |
*
* @param {Signup_Compare_Foot_PedalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_foot_pedal = /** @type {((inputs?: Signup_Compare_Foot_PedalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Foot_PedalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Foot Pedal Control")
	if (locale === "de") return /** @type {LocalizedString} */ ("Foot Pedal Control")
	if (locale === "it") return /** @type {LocalizedString} */ ("Foot Pedal Control")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Foot Pedal Control")
	if (locale === "es") return /** @type {LocalizedString} */ ("Foot Pedal Control")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Foot Pedal Control")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Foot Pedal Control")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Foot Pedal Control")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Foot Pedal Control")
	return /** @type {LocalizedString} */ ("Foot Pedal Control")
});